import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function InsightsErrorState() {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "badRequest",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "messaging-insights.insights.error.default"
    })
  });
}
export default InsightsErrorState;